module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAkCAYAAABBszIzAAAAAXNSR0IArs4c6QAAAKJJREFUeF7t2FERACAMw1AmcP7lwB028nAwko+2s7v3eNkfGAJk2f/DCdDmT4A4fwIQQAhMOyADpPELgXH8BCCAHaDtgAzQ5q8GxvkTgAB2gLQDMkAavxoYx08AAtgB2g7IAG3+amCcPwEIYAdIOyADpPGrgXH8BCCAHaDtgAzQ5q8GxvkTgAB2gLQDMkAavxoYx08AAtgB2g7IAG3+amCc/3nraER9x463dgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_eyes/nav_normal.png
// module id = vGPu
// module chunks = 2